/**
 * Email validation utility functions
 */

/**
 * Validates if an email address is in a valid format
 */
export const validateEmail = (email: string): boolean => {
  if (!email || typeof email !== 'string') {
    return false;
  }
  
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email.trim());
};

/**
 * Validates email and returns a user-friendly error message
 */
export const getEmailValidationError = (email: string): string => {
  if (!email || !email.trim()) {
    return 'Email is required';
  }
  
  if (!validateEmail(email)) {
    return 'Please enter a valid email address';
  }
  
  return '';
};

/**
 * Validates alternate email (optional field)
 */
export const getAlternateEmailValidationError = (email: string, primaryEmail: string = ''): string => {
  // Alternate email is optional, so empty is valid
  if (!email || !email.trim()) {
    return '';
  }
  
  if (!validateEmail(email)) {
    return 'Please enter a valid alternate email address';
  }
  
  // Check if alternate email matches primary email
  if (primaryEmail && email.toLowerCase().trim() === primaryEmail.toLowerCase().trim()) {
    return 'Alternate email cannot be the same as your primary email';
  }
  
  return '';
};
